import { combineReducers } from 'redux';
import errors from './errors.reducer';
import user from './user.reducer';
import clientReducer from './client.reducer';
import partnerReducer from './partner.reducer';
import requestReducer from './request.reducer';
import emailSettings from './emailSettings.reducer';
import warehouseReducer from './warehouse.reducer';
import referralPartnerReducer from './referral.partner.reducer';
import statisticsReducer from './statistics.reducer';
import requestNewestReducer from './request.newest.reducer';
import requestNameReducer from './request.name.reducer';
// rootReducer is the primary reducer for our entire project
// It bundles up all of the other reducers so our project can use them.
// This is imported in index.js as rootSaga

// Lets make a bigger object for our store, with the objects from our reducers.
// This is what we get when we use 'state' inside of 'mapStateToProps'
const rootReducer = combineReducers({
  errors, // contains registrationMessage and loginMessage
  user, // will have an id and username if someone is logged in
  clientReducer, // will contain all client info for CSV export
  partnerReducer, // will contain referral partner info
  requestReducer, // will contain request info 
  emailSettings,
  warehouseReducer,
  referralPartnerReducer,
  statisticsReducer,
  requestNewestReducer,
  requestNameReducer,
});

export default rootReducer;
